import { render } from "./subscribe-details-table.vue?vue&type=template&id=3ddeb605&scoped=true&ts=true"
import script from "./subscribe-details-table.vue?vue&type=script&lang=ts"
export * from "./subscribe-details-table.vue?vue&type=script&lang=ts"

import "./subscribe-details-table.vue?vue&type=style&index=0&id=3ddeb605&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ddeb605"]])

export default __exports__